import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {FlightLogComponent} from './components/flight-log/flight-log.component';
import {FlightService} from './services/flight/flight.service';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UtilitiesModule} from '../utilities/utilities.module';
import {RouterModule} from '@angular/router';
import {FlightInfoService} from './services/flight/flight-info-service';

@NgModule({
  declarations: [
    FlightLogComponent,
    DashboardComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    UtilitiesModule,
    RouterModule
  ],
  exports: [
    FlightLogComponent,
    DashboardComponent
  ],
  providers: [
    FlightService,
    FlightInfoService
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/dashboard/dashboard.module.ts